import $ from 'jquery';
import { colors } from '../colors';
import { pie } from '../options';

class ProductPopularity1 {
  constructor() {
  }

  static Chart() {
    let ctx = $('#charts__product-popularity_1');
    let check = $('canvas').is('#charts__product-popularity_1');
    let project_id = $('[data-project-id]').data('project-id');

    if(check) {
      $.ajax({
        url: '/api/v1/statistics/products_total?project_id=' + project_id,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
          initChart(response)
        }
      });

      let initChart = function(response){
        let data = {
          labels: response.labels,

          datasets: [
            {
              data: response.data,
              backgroundColor: [ colors.blue[300], colors.red[300], colors.orange[300], colors.green[300] ],
              hoverBackgroundColor: [ colors.blue[500], colors.red[500], colors.orange[500], colors.green[500] ],
              borderColor: [ colors.blue[500], colors.red[500], colors.orange[500], colors.green[500] ],
              hoverBorderColor: [ colors.blue[500], colors.red[500], colors.orange[500], colors.green[500] ],
              fill: true,

              datalabels: {
                color: [colors.white.primary, colors.white.primary, colors.black.primary, colors.white.primary]
              }
            }
          ]
        }

        var total_sum = response.data.reduce((a, b) => a + b, 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        var options = Object.assign({}, pie, {title: {display: true, text: ('Всего ' + total_sum), position: 'bottom'}});

        new Chart(ctx, {
          type: "pie",
          data: {
            labels: data.labels,
            datasets: data.datasets
          },
          options: options
        });
      }
    }
  }

  static onInit() {
    ProductPopularity1.Chart();
  }
}

export default ProductPopularity1;
